import { TAppState } from '../../types/appState';

export function currentOpenChatIDSelector(state: TAppState) {
  const { chatList, chatWindow } = state;

  return chatWindow.currentOpenedChatId || chatList.removedFromSpamChatId || chatList.removedFromArchiveChatId;
}
